<template>
  <div class="item-card" @touchstart="handleTouchStart" @touchend="handleTouchEnd" @touchcancel="handleTouchCancel">
    <div class="item-row">
      <div style="font-size:15px;font-weight:700;">{{ 작업허가명 }}</div>
    </div>
    <div v-if="작업시간" style="font-size:12px;font-weight:400;color:#9ca0a4;">{{ 작업시간 }}</div>
    <div v-if="작업대상" style="font-size:12px;">{{ 작업대상 }}</div>
    <div style="height:8px;"><!--빈칸--></div>
    <div v-if="작업장소" style="font-size:15px;font-weight:700;">{{ 작업장소 }}</div>
    <div v-if="작업내용" style="width:100%;font-size:14px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ 작업내용 }}</div>
  </div>
</template>

<script>
export default {
  name: 'QrAccessItem',
  props: {
    value: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      작업허가명: '',
      작업시간: '',
      사업장명: '',
      업체명: '',
      작업장소: '',
      작업내용: '',
      touchStartX: 0, // 터치 시작 X 좌표
      touchStartY: 0, // 터치 시작 Y 좌표
    };
  },
  computed: {
    작업대상 () {
      const temp = [];
      if (this.사업장명) temp.push(this.사업장명);
      if (this.업체명) temp.push(this.업체명);
      return temp.join(' | ');
    }
  },
  mounted() {
    this.getWorkPermitName();
    this.getWorkTime();
    this.getFieldName();
    this.getCompanyName();
    this.getZoneName();
    this.getWorkContent();
  },
  methods: {
    // 작업허가명
    getWorkPermitName() {
      const contents = this.value.post_contents;
      for (const content of contents) {
        if (content.data_key === 'body.작업정보.작업허가명') {
          this.작업허가명 = content.data_value;
          return;
        }
      }
      this.작업허가명 = this.value.board.board_title || this.value.post_title;
    },

    // 작업시간
    getWorkTime() {
      const contents = this.value.post_contents;
      let date = '';
      let startTime = '';
      let endTime = '';
      for (const content of contents) {
        if (content.data_key === 'body.작업허가.작업시간.시작') {
          startTime = content.data_value || '';
        } else if (content.data_key === 'body.작업허가.작업시간.종료') {
          endTime = content.data_value || '';
        } else if (content.data_key === 'body.작업허가.작업시작일시') {
          date = content.data_value || '';
        }
      }

      const temp1 = [];
      if (date) temp1.push(date);
      if (startTime) temp1.push(startTime);
      const start = temp1.join(' ');

      const temp2 = [];
      if (start) temp2.push(start);
      if (endTime) temp2.push(endTime);
      this.작업시간 = temp2.join(' ~ ');
    },

    // 사업장명
    getFieldName() {
      const contents = this.value.post_contents;
      for (const content of contents) {
        if (content.data_key === 'field.field_name') {
          this.사업장명 = content.data_value || '';
          return;
        }
      }
      if (this.value.field) {
        this.사업장명 = this.value.field.field_name || '';
      } else {
        this.사업장명 = '';
      }
    },

    // 업체명
    getCompanyName() {
      const contents = this.value.post_contents;
      for (const content of contents) {
        if (content.data_key === 'body.작업정보.업체명.com_name') {
          this.업체명 = content.data_value;
          return;
        }
      }
      this.업체명 = '';
    },
    getZoneName() {
      const contents = this.value.post_contents;
      for (const content of contents) {
        if (content.data_key === 'body._etc.작업장소.zone.name') {
          this.작업장소 = content.data_value;
          return;
        }
      }
      this.작업장소 = '';
    },
    getWorkContent() {
      const contents = this.value.post_contents;
      for (const content of contents) {
        if (content.data_key === 'body.작업정보.작업내용') {
          this.작업내용 = content.data_value;
          return;
        }
      }
      this.작업내용 = '';
    },

    handleTouchStart(event) {
      // 터치 시작 위치 저장
      this.touchStartX = event.touches[0].clientX;
      this.touchStartY = event.touches[0].clientY;
      // 강조 효과 추가
      event.currentTarget.classList.add('active');
    },
    handleTouchEnd(event) {
      // 터치 종료 위치 확인
      const touchEndX = event.changedTouches[0].clientX;
      const touchEndY = event.changedTouches[0].clientY;
      // 이동 거리 계산
      const deltaX = Math.abs(touchEndX - this.touchStartX);
      const deltaY = Math.abs(touchEndY - this.touchStartY);
      // 강조 효과 제거
      event.currentTarget.classList.remove('active');

      // 터치 이동 거리가 10px 이하일 경우만 클릭 이벤트 발생
      if (deltaX < 10 && deltaY < 10) {
        this.$emit('click'); // 클릭 이벤트 emit
      }
    },
    handleTouchCancel(event) {
      event.currentTarget.classList.remove('active');
    },
  }
}
</script>

<style scoped lang="scss">
.item-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 8px 0;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 2px 8px #00000041;
  background-color: white;


  .item-row {
    display: flex;
    flex-direction: row;
  }
}
</style>

<style scoped lang="scss">
.item-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 8px 0;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 2px 8px #00000041;
  background-color: white;
  transition: all 0.3s ease;

  border: 2px solid transparent;

  .item-row {
    display: flex;
    flex-direction: row;
  }

  // 마우스 hover 상태
  //&:hover {
  //  border: 2px solid #007bff;
  //  background-color: #f8f9fa;
  //  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.2);
  //}

  // 터치 또는 클릭 시 활성화 상태
  &.active {
    border: 2px solid #007bff;
    background-color: #f8f9fa;
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.2);
  }
}
</style>
